module.exports = __webpack_public_path__ + "img/icon.9b09bd13.png";